import store from '../store'

const mixin = {
    computed: {
        reports() {
            return this.$store.getters.reports
        },
        archive() {
            return this.$store.getters.archive
        },
    },
    methods: {
        getCarReports(){
            var self = this
            self.archive.filter = {
                search: self.report.id_car,
                perPage: 50,
                page: 1,
                onlyAldReports: 1
            }
            self.$root.ui.loading.push('getReports')
            return this.$store.dispatch('getReports', self.archive.filter).then(function(res){
                console.log(res);
                self.$root.ui.stopLoading('getReports')
            })
        },
        getReportStatusLabel(report){
            let res = '';
            let status = parseInt(report.report_status);
            let recipientStatus = parseInt(report.recipient_status);

            let priceStatus = '';

            if(status == 4 && parseInt(report.without_price)){
                priceStatus = '<i class="material-icons">assignment</i>'
            }

            if(status == 4)
                res += '<i class="material-icons">login</i>' + priceStatus;
            else if(status == 5)
                res += '<i class="material-icons">logout</i>';

            if(recipientStatus == 1)
                res += ' Swap';
            else if(recipientStatus == 2)
                res += ' Flexible';

            return res;
        },
        isMadeByCurrentUser(report){
            let id = parseInt(this.$root.user.ID);
            let id_parent_report = parseInt(report.id_parent_report);

            if( id_parent_report ){
                return id == parseInt(report.id_client)
            }else{
                if(this.$root.isAdministrator() && report.workshop_name == 'Autotaksering AS')
                    return true;
                return id == parseInt(report.id_user)
            }
        },
        openReport(report){
            location.hash = '#/reports/' + report.id
        },
        getReportOwnerName(report){
            if( parseInt(report.id_parent_report) )
                return report.client_name;
            if( parseInt(report.id_report_type)==3 )
                return 'Autotaksering AS';
            return report.workshop_name;
        },
        getReportInshuranceCompany(report){
            return report.insurance_company;
        },
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/reports.js